<template>
  <div ref="container">
    <a-modal :title="title" :width="1300" :visible="visible" :maskStyle="{ 'top': '93px', 'left': '154px' }" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:20%;height:80%;">
      <a-table :loading="loading" :dataSource="dataSource" :pagination="ipagination" :columns="columns" @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="myHandleDetailPI(record)">PI列表</a>
          <a-divider type="vertical" />
          <a @click="Print(record)">打印</a>
          <a-divider type="vertical" />
          <a @click="$emit('myHandleCopyAdd', record)">导出</a>
        </span>
        <span slot="startDate" slot-scope="text, record">
          <span v-if="record.startDate">{{ changeDate(record.startDate) }}</span>
          <span v-else></span>
        </span>
        <span slot="endDate" slot-scope="text, record">
          <span v-if="record.endDate">{{ changeDate(record.endDate) }}</span>
          <span v-else></span>
        </span>
      </a-table>
    </a-modal>
    <PIreorcd ref="PIreorcdref"></PIreorcd>
    <allSelectModel ref="allSelectModelRef"></allSelectModel>
  </div>
</template>
<script>
import PIreorcd from './PIreorcd.vue'
import { piRecord, exportPiExcelById } from '@/api/api'
import { getActionBlob } from '@/api/manage'
import allSelectModel from './allSelectModel.vue'
import { getNowFormatStr } from '@/utils/util'
export default {
  name: 'VendorModal',
  components: {
    PIreorcd,
    allSelectModel,
  },
  data() {
    return {
      title: '查看PI记录',
      visible: false,
      model: {},
      dataSource: [],
      loading: false,
      id: '',
      specificationId: '',
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      columns: [
        {
          title: '产品UDI编码',
          dataIndex: 'productDi',
        },
        {
          title: '产品名称',
          dataIndex: 'productName',
        },
        {
          title: '生产日期',
          dataIndex: 'startDate',
          scopedSlots: { customRender: 'startDate' },
        },
        {
          title: '生产批号',
          dataIndex: 'batchNumber',
        },
        {
          title: '灭菌批号',
          dataIndex: 'dBatchNumber',
        },
        {
          title: '失效日期',
          dataIndex: 'endDate',
          scopedSlots: { customRender: 'endDate' },
        },
        {
          title: '有效期',
          dataIndex: 'effectiveDate',
        },
        {
          title: 'UDI码数量',
          dataIndex: 'codeNum',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 180,
          scopedSlots: { customRender: 'action' },
        },
      ],
      ul: {
        haha: '/productPi/exportPiExcelByPiId'
      }
    }
  },
  created() {},
  methods: {
    changeDate(Date) {
      return Date.substring(0, 10)
    },
    // handleTableChange() {},
    async add(e) {
      this.visible = true
      if (e.id && e.specificationId) {
        this.id = e.id
        this.specificationId = e.specificationId
        this.ipagination.pageSize = 10
        this.ipagination.current = 1
        this.getlist()
      }
    },
    async getlist() {
      this.loading = true
      let params = {
        productId: this.id,
        specificationId: this.specificationId,
        page: this.ipagination.current,
        limit: this.ipagination.pageSize,
      }
      const res = await piRecord(params)
      if (res.errno == 200 && res.errmsg == '成功') {
        this.dataSource = res.data.list
        this.ipagination.total = res.data.total
        this.loading = false
      }else{
        this.$message.success(res.errmsg)
      }
    },
    handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc'
      }
      if (pagination && pagination.current) {
        this.ipagination = pagination
      }
      this.getlist()
    },
    async myHandleDetailPI(record) {
      this.$refs.PIreorcdref.add(record)
    },
    // 打印
    Print(record) {
      let type = 'Batchprint'
      this.$refs.allSelectModelRef.addStr(record, type)
    },
    // myHandleCopyAddChoose(fileName, res){
    //   const that = this
    //   this.$confirm({
    //     title: "导出",
    //     content: "请选择导出类型?",
    //     okText: "导出excel",
    //     cancelText: "导出txt",
    //     maskClosable: true,
    //     okButtonProps: {
    //       style: { backgroundColor: '#1890ff', borderColor: '#1890ff' }
    //     },
    //     cancelButtonProps: {
    //       style: { backgroundColor: '#1890ff', borderColor: '#1890ff',color:'#fff' }
    //     },
    //     onOk: function () {
    //       that.myHandleCopyAdd(fileName, res,'excel')
    //     },
    //     onCancel:function(){
    //       that.myHandleCopyAdd(fileName, res,'txt')
    //     }
    //   })
    // },
    /* 导出 - 点击事件 */
    // async myHandleCopyAdd(fileName, res, type) {
    //
    //   let hehe = {
    //     id: res.id
    //   }
    //   if (!fileName || typeof fileName != "string") {
    //     fileName = "导出文件"
    //   }
    //   let searchObj = {}
    //   searchObj.search = JSON.stringify(this.queryParam)
    //   searchObj.currentPage = this.ipagination.current
    //   searchObj.pageSize = this.ipagination.pageSize
    //   getActionBlob(this.ul.haha, hehe).then((data) => {
    //     if (!data) {
    //       this.$message.warning("文件下载失败")
    //       return
    //     }
    //     if (typeof window.navigator.msSaveBlob !== 'undefined') {
    //       window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
    //     } else {
    //       let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
    //       let link = document.createElement('a')
    //       link.style.display = 'none'
    //       link.href = url
    //       link.setAttribute('download', fileName + '_' + getNowFormatStr() + '.xls')
    //       document.body.appendChild(link)
    //       link.click()
    //       document.body.removeChild(link) //下载完成移除元素
    //       window.URL.revokeObjectURL(url) //释放掉blob对象
    //     }
    //   })
    // },

    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      // 触发表单验证
      this.handleCancel()
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>
<style scoped></style>